exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-610b3d74],.loader[data-v-610b3d74]:after{border-radius:50%;width:10em;height:10em}.loader[data-v-610b3d74]{margin:60px auto;font-size:10px;position:relative;text-indent:-9999em;border-top:1.1em solid rgba(53,73,94,.2);border-right:1.1em solid rgba(53,73,94,.2);border-bottom:1.1em solid rgba(53,73,94,.2);border-left:1.1em solid #35495e;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation:load8-data-v-610b3d74 1.1s infinite linear;animation:load8-data-v-610b3d74 1.1s infinite linear}@-webkit-keyframes load8-data-v-610b3d74{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes load8-data-v-610b3d74{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-610b3d74","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Spinner.vue
// module id = 23
// module chunks = 0